export default __webpack_public_path__ + "static/media/ultras.b663a5e6.png";